import PropTypes from 'prop-types';
import styled from 'styled-components';
import { getTranslation } from '../../../translations/translations';

const Wrapper = styled.div`
  display: inline-block;
  margin: 0 0 0.5em;
  padding: 0.3em 1em;
  background: #0176a2;
  color: #fff;
  font-weight: normal;
  font-size: 12px;

  p {
    margin-bottom: 0;
  }
`;

const ListItemCountdownLabel = ({ countdownClassSuffix, id }) => (
  <Wrapper
    className={`countdown-label ${countdownClassSuffix ? countdownClassSuffix : ''}`}
    id={`countdown_${id}`}
  >
    <p>{getTranslation('countdownSaleSearchTranslation')}</p>
  </Wrapper>
);

ListItemCountdownLabel.propTypes = {
  countdownClassSuffix: PropTypes.string,
  id: PropTypes.string.isRequired
};

ListItemCountdownLabel.defaultProps = {
  countdownClassSuffix: undefined
};

export default ListItemCountdownLabel;
